import { Form, InputGroup } from 'react-bootstrap'
import React, { memo } from 'react'

import PropTypes from 'prop-types'
import { useField } from 'formik'

const CheckboxField = ({ label, type = 'checkbox', ...props }) => {
  const [field, meta] = useField(props.name)

  return (
    <Form.Group controlId={`validationFormik${field.name}`}>
      <InputGroup hasValidation>
        <Form.Check
          type={type}
          label={label}
          {...field}
          {...props}
          isInvalid={meta.error && meta.touched}
          checked={field.value}
        />
        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  )
}

export default memo(CheckboxField)

CheckboxField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
}
